import styled from "styled-components";

export const FormPass = styled.div`
    min-width: 400px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;